import type React from "react";

type Props = {
    title: React.ReactNode;
    sub?: React.ReactNode;
    right?: React.ReactNode;
    id?: string;
    children: React.ReactNode;
};

/** A titled block of the bundle page (the design's `.ci-sec`). */
export const Section: React.FC<Props> = ({title, sub, right, id, children}) => (
    <section className="ci-sec" id={id}>
        <div className="ci-sech">
            <div>
                <h2 className="ci-h2">{title}</h2>
                {sub && <span className="ci-sub">{sub}</span>}
            </div>
            {right && <div className="ci-sech-r">{right}</div>}
        </div>
        {children}
    </section>
);
